import * as actionTypes from '../actionTypes/comments';

export default {
  addCommentsData: (data) => ({
    type: actionTypes.ADD_COMMENTS_DATA,
    payload: { ...data },
  }),
  getComments: () => ({
    type: actionTypes.GET_COMMENTS,
    payload: {},
  }),
  updatePopUpKeys: (data) => {
    return {
      type: actionTypes.UPDATE_POPUP_KEYS,
      payload: { ...data },
    };
  },
  updateCommentData: (data) => ({
    type: actionTypes.UPDATE_COMMENT_DATA,
    payload: { ...data },
  }),
  addComment: (data) => ({
    type: actionTypes.ADD_COMMENT,
    payload: { ...data },
  }),
  deleteComment: (data) => ({
    type: actionTypes.DELETE_COMMENT_DATA,
    payload: { ...data },
  }),
  changeCommentCount: (data) => ({
    type: actionTypes.CHANGE_COMMENT_COUNT,
    payload: { ...data },
  }),
};
